import { Component, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BroadcastEvent } from '@interfaces/broadcast.interface';
import { DeviceType, NavigationPage } from '@interfaces/common.interface';
import { GlobalService } from '@app/services/global.service';
import { IntercomService } from '@app/services/intercom.service';
import { NavigationService } from '@app/services/navigation.service';
import { SessionService } from '@app/services/session.service';

@Component({
  selector: 'ark-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent {
  public navigationHidden = true;
  public menuHidden = false;
  nftPage = false;
  selectedPackage = '';
  loggedIn = false;
  public openProfile = false;
  public currentRoute = '';
  public currentSection = 'home';
  public hiddenNavPages = ['/legacy/join/invitation', '/legacy/join'];
  public hiddenMenu = ['/legacy/join/membership', '/legacy/join/nft'];

  constructor(
    private session: SessionService,
    private global: GlobalService,
    private router: Router,
    private navigation: NavigationService,
    private intercom: IntercomService,
  ) {
    this.intercom.on(BroadcastEvent.SHOW_NAVIGATION, () => {
      this.menuHidden = false;
    });
    this.intercom.on(BroadcastEvent.HIDE_NAVIGATION, () => {
      this.menuHidden = true;
    });
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.currentRoute = val.urlAfterRedirects.split('?')[0];
        this.currentSection = val.urlAfterRedirects.split('/')[1];
        this.navigationHidden = this.hiddenNavPages.includes(this.currentRoute);
        this.menuHidden = this.hiddenMenu.includes(this.currentRoute);
        if (this.currentRoute === '/legacy/join/nft') {
          this.nftPage = true;
          const pack = this.global.get('selectedPackage');
          if (pack) {
            this.selectedPackage = pack.title;
          }
        } else {
          this.nftPage = false;
        }
      }
    });
  }

  public toggleProfile(): void {
    this.openProfile = !this.openProfile;
  }

  goto(section: any) {
    if (section !== this.currentRoute) {
      this.currentSection = section;
      this.navigation.goTo(section).then();
    }
  }

  gotoPackages(): void {
    this.navigation.goTo('/legacy/join/membership');
  }

  // getNft() {
  //   this.nftSrv.myNfts().then(myNft => {
  //     const apiUrl = environment.apiBaseUrl;
  //     this.nftImgUrl = myNft[0]?.nftImageUrl;
  //     this.nftItemId = myNft[0]?.nftItemId;
  //     this.nftUrl = `${apiUrl}/nft/myNfts/downloadBadge?nftItemId=${this.nftItemId}`
  //   })
  // }

  public async logOut() {
    await this.session.logout();
  }
}
